// extracted by mini-css-extract-plugin
export default {"container":"DT-z","leftColumn":"ET-z","rightColumn":"FT-z","item":"GT-z"};